// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".link-block{border:1px solid #ebf0f6;background-color:#fff;margin-right:15px;margin-bottom:15px;padding:4px;display:flex;flex-direction:column;width:70px;height:70px}.link-block a,.link-block a img{width:100%;height:100%}.link-block a img{-o-object-fit:contain;object-fit:contain}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
